import React from 'react';

import EventModalTimeOff from 'scheduler/components/EventModalTimeOff';

const EventModal = ({ tag, event, onClose, onDeleteEvent, dayView }) => <EventModalTimeOff tag={tag} dayView={dayView} event={event} onClose={onClose} onDeleteEvent={onDeleteEvent} />;

export default EventModal;
